import '@angular/compiler';
import 'core-js/stable';
import 'zone.js';
// import 'zone.js/dist/zone.js';
import '@angular/localize/init';
import 'regenerator-runtime/runtime';

import './app.module';
import * as angular from "angular";


import './app.config';
import './app.run';
import './config.route';
import './config.triangular.themes';
import './app.scss';

import './app-component.component';
import './app-component.scss';

import './triangular';
import './translate';
import './permission';
import './modules';
import './layouts';
// import {AppModule} from "./app.module";
// import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
//
// platformBrowserDynamic().bootstrapModule(AppModule);

// Snapshot the raw query string before AngularJS bootstraps and ui-router gets a chance
// to sync/rewrite the visible URL - a social-login OAuth redirect (Google/Microsoft)
// lands on '/', which isn't a declared ui-router state, so there's no way to protect its
// query params the way the SSO '/token' state's params are protected. Downstream code
// reads this snapshot instead of window.location.search to avoid that race.
(window as any).__initialLocationSearch = window.location.search;

angular.bootstrap(document.body, ['ngApp']);
